import { warnOnce as f } from "./atoms-v2942.js";
import { motionValue as n } from "./atoms-v2880.js";
import { isMotionValue as u } from "./atoms-v2884.js";
function c(i, t, s) {
  for (const o in t) {
    const e = t[o], r = s[o];
    if (u(e))
      i.addValue(o, e), process.env.NODE_ENV === "development" && f(e.version === "11.18.2", `Attempting to mix Motion versions ${e.version} with 11.18.2 may not work as expected.`);
    else if (u(r))
      i.addValue(o, n(e, { owner: i }));
    else if (r !== e)
      if (i.hasValue(o)) {
        const a = i.getValue(o);
        a.liveStyle === !0 ? a.jump(e) : a.hasAnimated || a.set(e);
      } else {
        const a = i.getStaticValue(o);
        i.addValue(o, n(a !== void 0 ? a : e, { owner: i }));
      }
  }
  for (const o in s)
    t[o] === void 0 && i.removeValue(o);
  return t;
}
export {
  c as updateMotionValuesFromProps
};
